import type { ReactNode } from "react";
import { D, type Dec } from "@ftr/tax-core";
import { useTween } from "../lib/animate.ts";
import { pct, usd } from "../lib/format.ts";

/** A headline figure that counts to its value, then shows the exact formatted amount. */
export function Figure({ value, kind = "usd", places = 0, className }: { value: Dec; kind?: "usd" | "pct"; places?: number; className?: string }) {
  const target = value.toNumber();
  const { value: shown, settled } = useTween(target);
  const text = settled ? (kind === "usd" ? usd(value) : pct(value, places)) : kind === "usd" ? usd(new D(Math.round(shown))) : pct(new D(shown), places);
  return (
    <span className={"figure " + (className ?? "")} aria-live="polite">
      {text}
    </span>
  );
}

export function ResultCard({ title, children, tag = "2026 federal estimate" }: { title: string; children: ReactNode; tag?: string }) {
  return (
    <section className="result" id="result" aria-label={title}>
      <header className="result-head">
        <span>{title}</span>
        <span className="tag">{tag}</span>
      </header>
      {children}
    </section>
  );
}

export function Line({ label, value, note, strong, tone }: { label: ReactNode; value: ReactNode; note?: ReactNode; strong?: boolean; tone?: "good" | "warn" | "bad" }) {
  return (
    <div className={"rline" + (strong ? " rline--strong" : "") + (tone ? " rline--" + tone : "")}>
      <span className="rline-label">
        {label}
        {note && <span className="rline-note">{note}</span>}
      </span>
      <span className="rline-value">{value}</span>
    </div>
  );
}
